const PERSIST = 'client/persist/PERSIST';

function persist(fn) {
  return {
    resource: 'PERSISTENCE_RESOURCE',
    type: PERSIST,
    payload: fn,
  };
}

export const actions = {
  persist,
};

export default { actions };



// WEBPACK FOOTER //
// ./src/portfolio-shared/state/reducers/persistReducer.js